module.exports = __webpack_public_path__ + "img/lightningIcon.2e4dc482.svg";